import * as ui from '../ui.js'

// Trailing debounce for keystroke sync: a single keypress reflects without
// leaving the field (like date inputs), while fast typing ("500") only syncs
// the final value instead of intermediates ("5"). See OFFICE-2987.
const SYNC_DEBOUNCE_MS = 500
let syncTimer = null

export function initializeHeadParameters() {
    const minHeadElement = document.getElementById('minHead')
    const maxHeadElement = document.getElementById('maxHead')

    if (minHeadElement === null || maxHeadElement === null) return

    minHeadElement.addEventListener('input', handleHeadInput)
    maxHeadElement.addEventListener('input', handleHeadInput)
    minHeadElement.addEventListener('change', handleHeadCommit)
    maxHeadElement.addEventListener('change', handleHeadCommit)
}

function handleHeadInput(e) {
    ui.removeReport()

    clearTimeout(syncTimer)
    const sourceElement = e.currentTarget
    syncTimer = setTimeout(() => validateHeadRange(sourceElement), SYNC_DEBOUNCE_MS)
}

function handleHeadCommit(e) {
    clearTimeout(syncTimer)
    validateHeadRange(e.currentTarget)
}

function validateHeadRange(sourceElement) {
    ui.removeReport()

    const minHeadElement = document.getElementById('minHead')
    const maxHeadElement = document.getElementById('maxHead')

    if (minHeadElement.value === '' || maxHeadElement.value === '') return

    const minHead = Number(minHeadElement.value)
    const maxHead = Number(maxHeadElement.value)

    if (sourceElement === minHeadElement && minHead > maxHead) {
        maxHeadElement.value = minHeadElement.value
    }

    if (sourceElement === maxHeadElement && maxHead < minHead) {
        minHeadElement.value = maxHeadElement.value
    }
}
